<wl-card heading="Add New User">


    <mat-tab-group>
        <mat-tab label="Add Zone">
            <form class="w-75pct m-auto" novalidate [formGroup]="zoneForm">
                <div class="w-full">
                    <wl-autocomplete-nolabel class="flex-1-100" label="Enter State*" placeholder="Choose State*"
                        formControlName="state_name" [options]="states" (selected)="stateSelected($event)">
                    </wl-autocomplete-nolabel>
                </div>
            </form>
        </mat-tab>
        <mat-tab label="Add RO">
        </mat-tab>
        <mat-tab label="Add Branch">
        </mat-tab>
    </mat-tab-group>
    
    <wl-progress [hidden]="isDataPending"></wl-progress>

</wl-card>


